import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-radio-indicator',
  host: {
    '[class]': '_computedClass()',
  },
  template: `<div
    class="group-data-checked-disabled/radio:bg-components-content-neutral-quaternary group-data-checked-not-disabled/radio:bg-components-background-primary-main group-data-checked-[disabled=true]/radio:bg-components-background-primary-main size-[10px] rounded-full bg-transparent"
  ></div> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HlmRadioIndicator {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm(
      'relative mr-xs flex items-center justify-center aspect-square size-md shrink-0 rounded-full border border-stroke-primary-main transition-[color,box-shadow]',
      'outline-feedback-informative-main focus:outline-offset-2 focus:outline-2',
      'group-has-[:focus]:outline-2 group-has-[:focus]:outline-offset-2',
      'group-not-data-[disabled=true]/radio:group-hover/label:text-primary-lightest',
      'group-not-data-[disabled=true]/radio:group-hover/label:bg-transparent',
      'group-not-data-[disabled=true]/radio:group-hover/label:ring-grey-2',
      'group-not-data-[disabled=true]/radio:group-hover/label:ring-2',
      'group-data-[disabled=true]/radio:text-components-content-neutral-quaternary',
      'group-data-[disabled=true]/radio:border-components-content-neutral-quaternary',
      'group-data-[disabled=true]/radio:hover:bg-components-background-neutral-lightest',
      this.userClass(),
    ),
  );
}
